import { styled as styling } from "@mui/material/styles";

export const Wrapper = styling("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  height: "30svh",
  width: "100%",
  margin: "0 auto 7rem",
});

export const TextStyled = styling("p")({
  fontSize: "1.25rem",
  fontWeight: "500",
  lineHeight: "1.5rem",
  textAlign: "center",

  margin: "0",
});

export const ImageStyled = styling("img")({
  width: "250px",
  height: "250px",
});
